import { render } from "./LineBottom.vue?vue&type=template&id=c8290ef2&scoped=true"
import script from "./LineBottom.vue?vue&type=script&lang=js"
export * from "./LineBottom.vue?vue&type=script&lang=js"

import "./LineBottom.vue?vue&type=style&index=0&id=c8290ef2&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8290ef2"]])

export default __exports__